import LBox from "@components/LBox";
import LButton from "@components/LButton";
import { ScanModalSWMSheet } from "@components/modals/ScanModalSWM";
import { timeDiffText } from "@utils/time";
import dayjs from "dayjs";
import { useBottomSheetManager } from "react-native-bottom-sheet-stack";

const USE_RESTRICTED_SCANNING_TIME = false;
const SCAN_BEFORE_START_THRESHOLD_IN_SECONDS = 60 * 60; // 1 hour

type AccessScanTicketsButtonProps = {
  accessDate: string;
  accessId: string;
};

const AccessScanTicketsButton = ({
  accessDate,
  accessId,
}: AccessScanTicketsButtonProps) => {
  const bottomSheetManager = useBottomSheetManager();
  const secondsUntilStart = dayjs(accessDate).diff(dayjs(), "seconds");
  const canScanTickets = USE_RESTRICTED_SCANNING_TIME
    ? secondsUntilStart <= SCAN_BEFORE_START_THRESHOLD_IN_SECONDS
    : true;
  const scanTimeLeftText = timeDiffText(
    secondsUntilStart - SCAN_BEFORE_START_THRESHOLD_IN_SECONDS,
  );

  const handlePressButtonScanner = () => {
    bottomSheetManager.open(<ScanModalSWMSheet accessId={accessId} />, {
      mode: "push",
    });
  };

  return (
    <LBox borderRadius="s" overflow="hidden" width="100%">
      <LButton
        backgroundColor="challengeCardBg"
        enabled={canScanTickets}
        iconName="scanner"
        label={canScanTickets ? "SCAN TICKETS" : `SCAN IN ${scanTimeLeftText}`}
        onPress={handlePressButtonScanner}
        sentryEventName="scan_tickets_button_pressed"
        variant="primary"
      />
    </LBox>
  );
};

export default AccessScanTicketsButton;
